import { render } from "./boards.vue?vue&type=template&id=b834f5ae&scoped=true"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"

import "./boards.vue?vue&type=style&index=0&id=b834f5ae&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b834f5ae"]])

export default __exports__